import { createClient, type SupabaseClient } from '@supabase/supabase-js'

let _anonClient: SupabaseClient | undefined

export const supabaseIsOnline = ref(true)

const syncOnlineState = () => {
  if (import.meta.client) {
    supabaseIsOnline.value = navigator.onLine
  }
}

if (import.meta.client) {
  syncOnlineState()
  window.addEventListener('online', syncOnlineState)
  window.addEventListener('offline', syncOnlineState)
}

export const useSupabaseAnon = () => {
  if (_anonClient) {
    return _anonClient
  }

  const config = useRuntimeConfig()
  const url = config.public.supabase.url
  const anonKey = config.public.supabase.anonKey

  if (!url || !anonKey) {
    throw new Error(
      'Supabase config missing: set NUXT_PUBLIC_SUPABASE_URL and NUXT_PUBLIC_SUPABASE_ANON_KEY'
    )
  }

  _anonClient = createClient(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  })

  return _anonClient
}
